import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import Search from '@material-ui/icons/Search'
import { API, DATE } from '@const'
import * as utils from '@utils'
import { Grid, Divider, Button, Typography, FormControl, InputLabel, Select, MenuItem } from '@material-ui/core'
import { Decimal } from 'decimal.js'
import ComponentDialog from '@dialogs/component-dialog'
import { PfSubPfSelect, DateSelect, CompleteDecimal } from '@select'
import GameReportPage from './game-report-page'
import { PlayerBetReportTable, Table } from '@tables'
import GameRoundResultPage from './game-round-result-page'

const COMPONENT_GROUP = 'settlement_report'

class SettlementReportPage extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key) => {
            return utils.t(key, 'SettlementReportPage')
        }
    }

    state = {
        searchType: DATE.DATEPART_DAY,
        export: false,
        isRealTimeCaculation: false
    }

    columns = [
        {
            field: 'date',
            type: 'date',
        },
        {
            field: 'pf_sub_pf_id',
            type: 'platform',
        },
        {
            field: 'bet_player_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return (
                    <Button
                        className={this.props.classes.linkButton}
                        onClick={() => {
                            let startDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.startDate
                            let endDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.endDate
                            if (this.state.searchType === DATE.DATEPART_MONTH) {
                                startDate = utils.datetimeStartOfWithoutOffset(startDate, 'month').format()
                                endDate = utils.datetimeEndOfWithoutOffset(endDate, 'month').format()
                            }

                            this.compDialog.OpenDialog(
                                this.t('PlayerBetReportTable'),
                                <PlayerBetReportTable
                                    compDialogArgs={{
                                        apiUrl: API.BET_RECORD_SUM_LIST_BY_REPORT_PF_ACCOUNT,
                                        displayGameTypeCode: 'all',
                                        gameCode: 'all',
                                        startDate: startDate,
                                        endDate: endDate,
                                        pfId: this.pfSelect.state.pfId,
                                        pfSubPfId:
                                            rowData['pf_sub_pf_id'] !== 'all'
                                                ? rowData['pf_sub_pf_id']
                                                : this.pfSelect.state.pfSubPfId !== 'all'
                                                ? this.pfSelect.state.pfSubPfId
                                                : '',
                                        exportType: 'report_pf_account'
                                    }}>
                                </PlayerBetReportTable>
                            )
                        }}>
                        {display}
                    </Button>
                )
            },
        },
        {
            field: 'bet_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return <Button
                className={this.props.classes.linkButton}
                onClick={() => {
                    let startDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.startDate
                    let endDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.endDate
                    if (this.state.searchType === DATE.DATEPART_MONTH) {
                        startDate = utils.datetimeStartOfWithoutOffset(startDate, 'month').format()
                        endDate = utils.datetimeEndOfWithoutOffset(endDate, 'month').format()
                    }

                    this.compDialog.OpenDialog(
                        this.t('GameRoundResultPage'),
                        <GameRoundResultPage
                            compDialogArgs={{
                                dateUnit: 'day',
                                searchType: 'date',
                                displayGameTypeCode: 'all',
                                gameCode: 'all',
                                startDate: startDate,
                                endDate: endDate,
                                pfId: this.pfSelect.state.pfId,
                                pfSubPfId:
                                    rowData['pf_sub_pf_id'] !== 'all'
                                        ? rowData['pf_sub_pf_id']
                                        : this.pfSelect.state.pfSubPfId !== 'all'
                                            ? this.pfSelect.state.pfSubPfId
                                            : '',
                            }}></GameRoundResultPage>
                    )
                }}>
                {display}
            </Button>
            },
        },
        {
            field: 'buy_free_game_amount',
            type: 'numberByThous',
            render: (rowData, display) => {
                return <Button
                className={this.props.classes.linkButton}
                onClick={() => {
                    let startDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.startDate
                    let endDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.endDate
                    if (this.state.searchType === DATE.DATEPART_MONTH) {
                        startDate = utils.datetimeStartOfWithoutOffset(startDate, 'month').format()
                        endDate = utils.datetimeEndOfWithoutOffset(endDate, 'month').format()
                    }

                    this.compDialog.OpenDialog(
                        this.t('GameRoundResultPage'),
                        <GameRoundResultPage
                            compDialogArgs={{
                                dateUnit: 'day',
                                searchType: 'date',
                                displayGameTypeCode: 'all',
                                gameCode: 'all',
                                startDate: startDate,
                                endDate: endDate,
                                pfId: this.pfSelect.state.pfId,
                                purchase_method: 1,
                                pfSubPfId:
                                    rowData['pf_sub_pf_id'] !== 'all'
                                        ? rowData['pf_sub_pf_id']
                                        : this.pfSelect.state.pfSubPfId !== 'all'
                                            ? this.pfSelect.state.pfSubPfId
                                            : '',
                            }}></GameRoundResultPage>
                    )
                }}>
                {display}
            </Button>
            },
            
        },
        {
            field: 'bet',
            type: 'currency',
            render: (rowData, display) => (
                <Button
                    className={this.props.classes.linkButton}
                    onClick={() => {
                        let startDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.startDate
                        let endDate = rowData['date'] ? rowData['date'] : this.dateSelect.state.endDate
                        if (this.state.searchType === DATE.DATEPART_MONTH) {
                            startDate = utils.datetimeStartOfWithoutOffset(startDate, 'month').format()
                            endDate = utils.datetimeEndOfWithoutOffset(endDate, 'month').format()
                        }

                        this.compDialog.OpenDialog(
                            this.t('GameReportPage'),
                            <GameReportPage
                                compDialogArgs={{
                                    apiUrl: API.BET_RECORD_SUM_LIST_BY_REPORTGAME,
                                    dateUnit: 'day',
                                    displayGameTypeCode: 'all',
                                    gameCode: 'all',
                                    searchType: 'date',
                                    startDate: startDate,
                                    endDate: endDate,
                                    pfId: this.pfSelect.state.pfId,
                                    pfSubPfId:
                                        rowData['pf_sub_pf_id'] !== 'all'
                                            ? rowData['pf_sub_pf_id']
                                            : this.pfSelect.state.pfSubPfId !== 'all'
                                                ? this.pfSelect.state.pfSubPfId
                                                : '',
                                }}></GameReportPage>
                        )
                    }}>
                    {display}
                </Button>
            ),
        },
        {
            field: 'bet_valid',
            type: 'currency',
        },
        {
            field: 'operator_profit',
            type: 'currency',
            render: (row, display) => {
                const fontColor = row['operator_profit'] < 0 ? 'red' : ''
                return <div style={{ color: fontColor }}>{display}</div>
            },
        },
        {
            field: 'tax',
            type: 'currency',
        },
    ]

    componentDidMount() {
        if (utils.checkValid(COMPONENT_GROUP + '.export')) {
            this.setState({ export: true })
        }
    }

    queryData = () => {
        this.table.SetLoading(true)
        this.sumTable.SetLoading(true)

        if (this.state.searchType === DATE.DATEPART_DAY) this.columns[0].type = 'date'
        else if (this.state.searchType === DATE.DATEPART_MONTH) this.columns[0].type = 'datemonth'
        this.table.setColumns()

        const unit = this.state.searchType === DATE.DATEPART_MONTH ? 'month' : 'day'

        const queryParams = {
            start_date: utils.datetimeToUnix_startOf(this.dateSelect.state.startDate, unit),
            end_date: utils.datetimeToUnix_endOf(this.dateSelect.state.endDate, unit),
            pf_id: this.pfSelect.state.pfId !== 'all' ? this.pfSelect.state.pfId : '',
            pf_sub_pf_id: this.pfSelect.state.pfSubPfId !== 'all' ? this.pfSelect.state.pfSubPfId : '',
            timezone: DATE.CLIENT_UTC_OFFSET,
            datepart: this.state.searchType,
            is_real_time_caculation: this.state.isRealTimeCaculation,
        }

        utils.apiRequest(
            'get',
            API.BET_RECORD_SUM_LIST_BY_DATE,
            queryParams,
            (data) => {
                const currency = utils.getPfCurrency(queryParams['pf_id'])

                this.table.SetData(this.formatPlatformData(data.reports), currency)
                this.sumTable.SetData(this.formatPlatformData(data.sum_reports, true), currency)
            },
            (_err) => {
                this.table.SetData([])
                this.sumTable.SetData([])
            },
            true
        )
    }

    formatPlatformData(data, isSum) {
        let tempList = []
        data.forEach((elem) => {
            var temp = utils.deepCopy(elem)

            if (isSum) temp.date = null

            tempList.push(temp)
        })

        var sumPerDay = {}
        var count = 0
        tempList.sort((a, b) => utils.SortPlatform(a.pf_sub_pf_id, b.pf_sub_pf_id))
        tempList.forEach((item) => {
            if (sumPerDay[item.date] === undefined) {
                sumPerDay[item.date] = {
                    ...item,
                    id: ++count,
                    pf_sub_pf_id: 'all',
                }
            } else {
                Object.keys(sumPerDay[item.date]).forEach((key) => {
                    if (['id', 'date', 'pf_id', 'pf_sub_pf_id', 'pf_account_list'].indexOf(key) === -1) {
                        sumPerDay[item.date][key] = new Decimal(sumPerDay[item.date][key]).add(item[key])
                    }
                })
            }
            item.id = ++count
            item.parent = sumPerDay[item.date].id
        })
        tempList = tempList.concat(Object.values(sumPerDay))

        return tempList
    }

    render() {
        const totalTableOption = {
            export: this.state.export,
            toolbar: this.state.export,
            search: false,
            paging: false
        }
        return (
            <Grid container spacing={2}>
                <Grid item xs={12} className={this.props.classes.alignCenter}>
                    <FormControl className={this.props.classes.formControl}>
                        <InputLabel>{this.t('searchType')}</InputLabel>
                        <Select
                            value={this.state.searchType}
                            onChange={(event) =>
                                this.setState({
                                    searchType: event.target.value,
                                })
                            }>
                            <MenuItem value={DATE.DATEPART_DAY}>{this.t('dailyReport')}</MenuItem>
                            <MenuItem value={DATE.DATEPART_MONTH}>{this.t('monthlyReport')}</MenuItem>
                        </Select>
                    </FormControl>
                    <DateSelect datepart={this.state.searchType} onRef={(ref) => (this.dateSelect = ref)}></DateSelect>
                    <PfSubPfSelect
                        onRef={(ref) => (this.pfSelect = ref)}
                        options={{
                            hideAllPlatform: true
                        }}
                    />
                    <Grid item>
                        <Button variant="contained" color="primary" className={this.props.classes.button} onClick={() => this.queryData()}>
                            <Search className={this.props.classes.rightIcon} />
                            {this.t('search')}
                        </Button>
                    </Grid>
                    <Grid item>
                        <CompleteDecimal />
                    </Grid>
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Typography variant="h6">{this.t('total')}</Typography>
                    <Table
                        ownerName="SettlementReportPage"
                        columns={this.columns.slice(1)}
                        options={totalTableOption}
                        onRef={(ref) => (this.sumTable = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
                <Grid item xs={12}>
                    <Divider />
                </Grid>
                <Grid item xs={12}>
                    <Table
                        ownerName="SettlementReportPage"
                        columns={this.columns}
                        options={{ export: this.state.export }}
                        onRef={(ref) => (this.table = ref)}
                        parentChildData={(row, rows) => rows.find((a) => a.id === row.parent)}
                    />
                </Grid>
                <ComponentDialog onRef={(ref) => (this.compDialog = ref)}></ComponentDialog>
            </Grid>
        )
    }
}

const styles = (theme) => {
    return {
        formControl: {
            margin: theme.spacing(1),
            width: '150px',
        },
        button: {
            margin: theme.spacing(1),
        },
        rightIcon: {
            marginRight: theme.spacing(1),
        },
        linkButton: {
            background: 'none!important',
            border: 'none',
            padding: '0!important',
            color: '#1890ff',
            textDecoration: 'none',
            cursor: 'pointer',
            userSelect: 'text',
            outline: 'none !important',
            '& span': {
                justifyContent: 'flex-end',
            }
        },
        hide: {
            display: 'none',
        },
        alignCenter: {
            display: 'inline-flex',
            alignItems: 'center',
        },
        labelMarginClear: {
            margin: 0,
        },
    }
}

SettlementReportPage.propTypes = {
    classes: PropTypes.object.isRequired,
    auth: PropTypes.object,
    dataService: PropTypes.object,
}

export default hoc(styles)(SettlementReportPage)
